import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { FirebaseHelper } from '../../firebase-helper';
import { faThumbsUp, faThumbsDown, faL } from '@fortawesome/free-solid-svg-icons'
import './LikeButtons.scss';



function LikeButtons(props) {
    const [likes, setLikes] = useState(0);
    const [dislikes, setDislikes] = useState(0);

    const [isLike,setIsLike] = useState(false);
    const [isDislike,setIsDislike] = useState(false);

    useEffect(() => {
        checkLike();
        setLikes(props.likes)
        setDislikes(props.dislikes)
    }, [props.id]);

    function checkLike(){
        var like = localStorage.getItem("like-button-"+props.id);
        if(like==null){
            return;
        }

        if(like==="true"){
            setIsLike(true);
        }else if(like==="false"){
            console.log("setDislikes")
            setIsDislike(true);
        }

        console.log(like);
    }

    function like() {
        console.log("clicked like")
        if (isLike == true) {
            decreaseLikes();
            localStorage.removeItem("like-button-"+props.id);
            return;
        }

        setIsLike(true);
        if (isDislike) {
            decreaseDislikes();
        }
        var newValue = likes + 1;
        props.object.likes = newValue;
        setLikes(newValue)
        FirebaseHelper.increaseLikes(props.type, props.id);
        localStorage.setItem("like-button-"+props.id,true);
    }
    function dislike() {
        console.log("clicked dislike")
        if (isDislike == true) {
            decreaseDislikes();
            localStorage.removeItem("like-button-"+props.id);
            return;
        }

        setIsDislike(true);
        if (isLike) {
            decreaseLikes();
        }

        var newValue = dislikes + 1;
        props.object.dislikes = newValue;
        setDislikes(newValue)
        FirebaseHelper.increaseDislikes(props.type, props.id);
        localStorage.setItem("like-button-"+props.id,false);
    }


    function decreaseLikes() {
        if (likes <= 0) {
            return;
        }
        setIsLike(false);
        
        FirebaseHelper.decreaseLikes(props.type, props.id)
        var newValue = likes - 1;
        props.object.likes=newValue;
        setLikes(newValue)
    }
    function decreaseDislikes() {
        if (dislikes <= 0) {
            return;
        }
        setIsDislike(false);
        FirebaseHelper.decreaseDislikes(props.type, props.id)
        var newValue = dislikes - 1;
        props.object.dislikes=newValue;
        setDislikes(newValue)
    }

    const likeButton = (value) => {
        return (
            <div className='button-container like-button'>
                <span className={isLike===true?"active":""}>{value}</span>
                <button onClick={props.clickAble?like:()=>{}}>
                    <FontAwesomeIcon icon={faThumbsUp}/>
                </button>
            </div>
        );
    }

    const dislikeButton = (value) => {
        return (
            <div className='button-container dislike-button'>
                <span className={isDislike===true?"active":""}>{value}</span>
                <button onClick={props.clickAble?dislike:()=>{}}>
                    <FontAwesomeIcon icon={faThumbsDown}/>
                </button>
            </div>
        );
    }

    return (
        <div id={props.id} className='like-buttons-container'>
            {likeButton(likes)}
            {dislikeButton(dislikes)}
        </div>
    )
}

export default LikeButtons